import React, { useState, useEffect, useRef, use } from "react";
import { useDispatch } from 'react-redux'; // Import useDispatch
// import { updateIntegration } from './../Features/Integration/integrationSlice'; // Import action
import { updateIntegration, updateIntegrationTriggerDetails } from '@/Redux/slices/integrationSlice'; // Import action using alias


import AwsSns from '@/Common/svgicons/awssns';

import triggerRequestSchema from '@Common/data/triggerRequestSchema.json';
import triggerResponseSchema from '@Common/data/triggerResponseSchema.json';
import AwsSqs from "@/Common/svgicons/awssqs";
import AzureSb from "@/Common/svgicons/azureServicebus";
import GraphQlIcon from "@/Common/svgicons/graphqlIcon";


const OverviewDetails = ({ details, isLoading, error }) => {
  const dispatch = useDispatch(); // Get the dispatch function

  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownMethod, setShowDropdownMethod] = useState(false);
  const [selectedSourceOption, setSelectedSourceOption] = useState("Http Trigger");
  const [selectedTriggerHttpMethod, setSelectedTriggerHttpMethod] = useState("POST");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [SignatureHeaderKey, setSignatureHeaderKey] = useState("");
  const [ClientSecret, setClientSecret] = useState("");
  const [requestSchema, setRequestSchema] = useState("");
  const [responseSchema, setResponseSchema] = useState("");
  const [cronExpression, setCronExpression] = useState("");
  const [awsRegion, setAwsRegion] = useState("");
  const [awsAccessKeyId, setAwsAccessKeyId] = useState("");
  const [awsSecretAccessKey, setAwsSecretAccessKey] = useState("");
  const [awsSNSTopicArn, setAwsSNSTopicArn] = useState("");
  const [awsSQSQueueUrl, setAwsSQSQueueUrl] = useState("");
  const [azSbQueueName, setAzSbsQueueName] = useState("");
  const [azSbConnectionString, setAzSbConnectionString] = useState("");
  const [sfInstanceUrl, setSfInstanceUrl] = useState("");
  const [sfTopicName, setSfTopicName] = useState("");
  const [sfUserName, setSfUserName] = useState("");
  const [sfPassword, setSfPassword] = useState("");
  const [sfSecurityToken, setSfSecurityToken] = useState("");
  const [sfClientId, setSfClientId] = useState("");
  const [sfClientSecret, setSfClientSecret] = useState("");


  useEffect(() => {
    // Check if details are available and not null/undefined
    if (details) {
      setSelectedSourceOption(details.triggerDetails.triggerType || "Http Trigger");
      setSelectedTriggerHttpMethod(details.triggerDetails.triggerHttpMethod || "POST");
      setName(details.name || "");
      setDescription(details.description || "");
      setRequestSchema(details.triggerDetails.triggerRequestSchema || "");
      setResponseSchema(details.triggerDetails.triggerResponseSchema || "");
      setCronExpression(details.triggerDetails.triggerCronExpression || "");
      setSignatureHeaderKey(details.triggerDetails.triggerSignatureHeaderKey || "");
      setClientSecret(details.triggerDetails.triggerClientSecret || "");
      setAwsRegion(details.config.region_name);
      setAwsAccessKeyId(details.config.aws_access_key_id);
      setAwsSecretAccessKey(details.config.aws_secret_access_key);
      setAwsSNSTopicArn(details.config.topic_arn);
      setAwsSQSQueueUrl(details.config.queue_url);
      setAzSbsQueueName(details.config.queue_name);
      setAzSbConnectionString(details.config.connection_string);
      setSfInstanceUrl(details.config.instance_url);
      setSfTopicName(details.config.topic_name);
      setSfUserName(details.config.username);
      setSfPassword(details.config.password);
      setSfSecurityToken(details.config.security_token);
      setSfClientId(details.config.client_id);
      setSfClientSecret(details.config.client_secret);
    }
  }, [details]);

  const onDropDown = () => {
    setShowDropdown(!showDropdown);
  };

  const onDropDownMethod = () => {
    setShowDropdownMethod(!showDropdownMethod);
  };

  const fillSampleRequestSchema = () => {
    dispatch(updateIntegrationTriggerDetails({ key: 'triggerRequestSchema', value: JSON.stringify(triggerRequestSchema, null, 2) }));

  }

  const fillSampleResponseSchema = () => {
    // dispatch(updateIntegrationTriggerDetails(JSON.stringify(triggerResponseSchema, null, 2)));
    dispatch(updateIntegrationTriggerDetails({ key: 'triggerResponseSchema', value: JSON.stringify(triggerResponseSchema, null, 2) }));

    //)
    // dispatch(updateIntegration({ triggerDetails: { triggerResponseSchema: JSON.stringify(triggerResponseSchema, null, 2) } })); // Update the store directly
  }


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "int_name") {
      setName(value);
      dispatch(updateIntegration({ name: value })); // Update the store directly
    } else if (name === "descr") {
      setDescription(value);
      dispatch(updateIntegration({ description: value })); // Update the store directly
    } else if (name === "options") {
      console.log("Selected option:", value);
      setSelectedSourceOption(value);
      // dispatch(updateIntegrationTriggerDetails({ triggerDetails: { triggerType: value } })); // Update the store directly
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerType', value: value }));
    } else if (name === "request_schema") {
      setRequestSchema(value);
      // dispatch(updateIntegrationTriggerDetailsRequestSchema(value));
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerRequestSchema', value: value }));

      // dispatch(updateIntegrationTriggerDetails({ triggerDetails: { triggerRequestSchema: value } })); // Update the store directly
    } else if (name === "response_schema") {
      setResponseSchema(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerResponseSchema', value: value }));

      // dispatch(updateIntegrationTriggerDetailsResponseSchema(value));
      // dispatch(updateIntegrationTriggerDetails({ triggerDetails: { triggerResponseSchema: value } })); // Update the store directly
    } else if (name === "cron_expression") {
      setCronExpression(value);
      // dispatch(updateIntegrationTriggerDetails({ triggerDetails: { triggerCronExpression: value } })); // Update the store directly
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerCronExpression', value: value }));
    } else if (name === "header_key") {
      setSignatureHeaderKey(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSignatureHeaderKey', value: value }));
    } else if (name === "client_secret_key") {
      setClientSecret(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerClientSecret', value: value }));
    } else if (name === "awsRegion") {
      setAwsRegion(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerAwsRegion', value: value }));
    } else if (name === "awsAccessKeyId") {
      setAwsAccessKeyId(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerAwsAccessKeyId', value: value }));
    } else if (name === "awsSecretAccessKey") {
      setAwsSecretAccessKey(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerAwsSecretAccessKey', value: value }));
    } else if (name === "awsSNSTopicArn") {
      setAwsSNSTopicArn(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerAwsSNSTopicArn', value: value }));
    } else if (name === "awsSQSQueueUrl") {
      setAwsSQSQueueUrl(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerAwsSQSQueueURL', value: value }));
    } else if (name === "azSbQueueName") {
      setAzSbsQueueName(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerAzSbQueueName', value: value }));
    } else if (name === "azSbConnectionString") {
      setAzSbConnectionString(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerAzSbConnectionString', value: value }));
    } else if (name === "sfInstanceUrl") {
      setSfInstanceUrl(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSfInstanceUrl', value: value }));
    } else if (name === "sfTopicName") {
      setSfTopicName(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSfTopicName', value: value }));
    } else if (name === "sfUserName") {
      setSfUserName(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSfUserName', value: value }));
    } else if (name === "sfPassword") {
      setSfPassword(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSfPassword', value: value }));
    } else if (name === "sfSecurityToken") {
      setSfSecurityToken(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSfSecurityToken', value: value }));
    } else if (name === "sfClientId") {
      setSfClientId(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSfClientId', value: value }));
    } else if (name === "sfClientSecret") {
      setSfClientSecret(value);
      dispatch(updateIntegrationTriggerDetails({ key: 'triggerSfClientSecret', value: value }));
    }
  };

  const onDropDownOptionSelected = (option) => {
    // dispatch(updateIntegration({ triggerDetails: { triggerHttpMethod: option } }));
    dispatch(updateIntegrationTriggerDetails({ key: 'triggerHttpMethod', value: option }));

    setSelectedTriggerHttpMethod(option);
    setShowDropdownMethod(false);
  }

  return (
    <div className="mb-6 pt-4 -ml-8">
      {details && details.triggerDetails.triggerType === "None" && (
        <div className="text-white px-8">
          <div className="space-y-4">
            <p className="text-sm font-medium text-white">
              Select the Trigger Type for your Integration
            </p>

            <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="option1-checkbox"
                  value="Http Trigger"
                  className="peer hidden"
                  checked={selectedSourceOption === "Http Trigger"} // Control with state
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="option1-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <svg
                      className="h-auto w-16"
                      viewBox="0 0 512 512"
                      fill="#000000"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <g>
                          {" "}
                          <path
                            style={{ fill: "#B0B6BB" }}
                            d="M308.145,406.069c-1.836,5.12-6.691,8.828-12.42,8.828h-70.621c-5.729,0-10.593-3.708-12.429-8.828 H5.102c-2.825,0-5.102,2.286-5.102,5.102v25.106c0,2.816,2.278,5.102,5.102,5.102h501.795c2.816,0,5.102-2.286,5.102-5.102v-25.106 c0-2.816-2.286-5.102-5.102-5.102H308.145z"
                          ></path>{" "}
                          <path
                            style={{ fill: "#E8EDEE" }}
                            d="M212.678,406.069c1.836,5.12,6.691,8.828,12.42,8.828h70.621c5.729,0,10.593-3.708,12.429-8.828 H494.34V97.103c0-14.627-11.855-26.483-26.483-26.483H44.133c-14.627,0-26.483,11.855-26.483,26.483v308.966H212.678z"
                          ></path>{" "}
                          <polygon
                            style={{ fill: "#7383BF" }}
                            points="52.963,370.759 459.032,370.759 459.032,105.931 52.963,105.931 "
                          ></polygon>{" "}
                          <g>
                            {" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M105.928,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C114.756,278.528,110.801,282.483,105.928,282.483"
                            ></path>{" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M158.894,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C167.721,278.528,163.767,282.483,158.894,282.483"
                            ></path>{" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M220.687,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C229.515,278.528,225.56,282.483,220.687,282.483"
                            ></path>{" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M158.894,247.172h-52.966c-4.873,0-8.828-3.955-8.828-8.828s3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828S163.767,247.172,158.894,247.172"
                            ></path>{" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M247.17,211.862h-52.966c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828C255.997,207.907,252.043,211.862,247.17,211.862"
                            ></path>{" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M308.963,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C317.79,278.528,313.836,282.483,308.963,282.483"
                            ></path>{" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M335.446,211.862H282.48c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828C344.273,207.907,340.318,211.862,335.446,211.862"
                            ></path>{" "}
                            <path
                              style={{ fill: "#FFFFFF" }}
                              d="M379.584,233.931h11.034c6.082,0,11.034-4.952,11.034-11.034s-4.952-11.034-11.034-11.034h-11.034 V233.931z M370.756,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828h19.862 c15.819,0,28.69,12.871,28.69,28.69s-12.871,28.69-28.69,28.69h-11.034v22.069C379.584,278.528,375.629,282.483,370.756,282.483 L370.756,282.483z"
                            ></path>
                          </g>{" "}
                        </g>{" "}
                      </g>
                    </svg>
                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        Http Trigger
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger it by HTTP request
                      </div>
                    </div>
                  </div>
                </label>
              </div>

              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="option2-checkbox"
                  value="Webhook Trigger"
                  className="peer hidden"
                  checked={selectedSourceOption === "Webhook Trigger"} // Control with state
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="option2-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <svg
                      className="h-auto w-16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.52 3.046a3 3 0 0 0-2.13 5.486 1 1 0 0 1 .306 1.38l-3.922 6.163a2 2 0 1 1-1.688-1.073l3.44-5.405a5 5 0 1 1 8.398-2.728 1 1 0 1 1-1.97-.348 3 3 0 0 0-2.433-3.475zM10 6a2 2 0 1 1 3.774.925l3.44 5.405a5 5 0 1 1-1.427 8.5 1 1 0 0 1 1.285-1.532 3 3 0 1 0 .317-4.83 1 1 0 0 1-1.38-.307l-3.923-6.163A2 2 0 0 1 10 6zm-5.428 6.9a1 1 0 0 1-.598 1.281A3 3 0 1 0 8.001 17a1 1 0 0 1 1-1h8.266a2 2 0 1 1 0 2H9.9a5 5 0 1 1-6.61-5.698 1 1 0 0 1 1.282.597Z"
                          fill="#000000"
                        ></path>{" "}
                      </g>
                    </svg>
                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        Webhook Trigger
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger it by webhook
                      </div>
                    </div>
                  </div>
                </label>
              </div>

              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="salesforce-checkbox"
                  value="SALESFORCE"
                  className="peer hidden"
                  checked={selectedSourceOption === "SALESFORCE"} // Control with state
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="salesforce-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <svg className="h-auto w-16" viewBox="0.5 -149.38 999 999" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#00A1E0" d="M416.224 76.763c32.219-33.57 77.074-54.391 126.682-54.391 65.946 0 123.48 36.772 154.12 91.361 26.626-11.896 56.098-18.514 87.106-18.514 118.94 0 215.368 97.268 215.368 217.247 0 119.993-96.428 217.261-215.368 217.261a213.735 213.735 0 0 1-42.422-4.227c-26.981 48.128-78.397 80.646-137.412 80.646-24.705 0-48.072-5.706-68.877-15.853-27.352 64.337-91.077 109.448-165.348 109.448-77.344 0-143.261-48.939-168.563-117.574-11.057 2.348-22.513 3.572-34.268 3.572C75.155 585.74.5 510.317.5 417.262c0-62.359 33.542-116.807 83.378-145.937-10.26-23.608-15.967-49.665-15.967-77.06C67.911 87.25 154.79.5 261.948.5c62.914 0 118.827 29.913 154.276 76.263"></path><path fill="#FFF" d="M145.196 363.11c-.626 1.637.228 1.979.427 2.263 1.878 1.366 3.786 2.349 5.707 3.444 10.189 5.407 19.81 6.986 29.871 6.986 20.492 0 33.214-10.9 33.214-28.447v-.341c0-16.224-14.358-22.115-27.835-26.37l-1.75-.569c-10.161-3.302-18.927-6.147-18.927-12.836v-.355c0-5.721 5.123-9.934 13.064-9.934 8.823 0 19.297 2.932 26.042 6.66 0 0 1.978 1.281 2.704-.64.398-1.025 3.814-10.218 4.17-11.214.384-1.082-.299-1.879-.996-2.306-7.699-4.682-18.344-7.884-29.358-7.884l-2.049.014c-18.756 0-31.848 11.328-31.848 27.565v.342c0 17.119 14.444 22.669 27.978 26.54l2.177.669c9.862 3.031 18.358 5.635 18.358 12.58v.342c0 6.347-5.521 11.071-14.43 11.071-3.458 0-14.487-.071-26.398-7.6-1.438-.84-2.277-1.451-3.387-2.12-.583-.37-2.049-1.011-2.689.925l-4.045 11.215zM445.194 363.11c-.626 1.637.228 1.979.427 2.263 1.878 1.366 3.786 2.349 5.706 3.444 10.189 5.407 19.811 6.986 29.871 6.986 20.492 0 33.215-10.9 33.215-28.447v-.341c0-16.224-14.359-22.115-27.836-26.37l-1.75-.569c-10.161-3.302-18.928-6.147-18.928-12.836v-.355c0-5.721 5.123-9.934 13.064-9.934 8.823 0 19.297 2.932 26.043 6.66 0 0 1.978 1.281 2.703-.64.398-1.025 3.814-10.218 4.17-11.214.385-1.082-.299-1.879-.996-2.306-7.699-4.682-18.344-7.884-29.358-7.884l-2.05.014c-18.756 0-31.848 11.328-31.848 27.565v.342c0 17.119 14.444 22.669 27.978 26.54l2.177.669c9.862 3.031 18.373 5.635 18.373 12.58v.342c0 6.347-5.536 11.071-14.445 11.071-3.457 0-14.486-.071-26.397-7.6-1.438-.84-2.291-1.423-3.372-2.12-.371-.242-2.107-.911-2.705.925l-4.042 11.215zM649.995 328.74c0 9.919-1.85 17.731-5.493 23.253-3.601 5.465-9.051 8.126-16.649 8.126-7.613 0-13.035-2.647-16.579-8.126-3.587-5.507-5.407-13.334-5.407-23.253 0-9.904 1.82-17.703 5.407-23.168 3.544-5.407 8.966-8.04 16.579-8.04 7.599 0 13.049 2.633 16.664 8.04 3.629 5.464 5.478 13.263 5.478 23.168m17.106-18.386c-1.68-5.679-4.298-10.688-7.784-14.857-3.487-4.184-7.898-7.542-13.136-9.99-5.223-2.433-11.398-3.671-18.328-3.671-6.945 0-13.121 1.238-18.344 3.671-5.237 2.448-9.648 5.807-13.149 9.99-3.472 4.184-6.091 9.193-7.784 14.857-1.665 5.649-2.505 11.825-2.505 18.386s.84 12.751 2.505 18.386c1.693 5.664 4.298 10.674 7.799 14.857 3.486 4.184 7.912 7.528 13.135 9.904 5.236 2.377 11.398 3.586 18.344 3.586 6.93 0 13.092-1.209 18.328-3.586 5.223-2.376 9.648-5.721 13.136-9.904 3.486-4.17 6.104-9.179 7.784-14.857 1.68-5.649 2.519-11.84 2.519-18.386s-.841-12.737-2.52-18.386M807.568 357.47c-.569-1.665-2.177-1.039-2.177-1.039-2.49.954-5.138 1.836-7.955 2.277-2.861.44-6.006.669-9.379.669-8.281 0-14.856-2.462-19.566-7.329-4.725-4.867-7.372-12.736-7.344-23.381.029-9.691 2.362-16.978 6.561-22.527 4.17-5.521 10.517-8.354 18.984-8.354 7.059 0 12.438.811 18.072 2.59 0 0 1.352.583 1.992-1.181 1.494-4.156 2.604-7.13 4.198-11.698.456-1.295-.654-1.85-1.053-2.007-2.22-.868-7.457-2.276-11.413-2.874-3.7-.569-8.026-.868-12.836-.868-7.188 0-13.591 1.224-19.069 3.672-5.465 2.433-10.104 5.791-13.775 9.976-3.672 4.184-6.461 9.192-8.325 14.856-1.85 5.649-2.789 11.854-2.789 18.415 0 14.188 3.828 25.657 11.385 34.054 7.57 8.425 18.941 12.708 33.77 12.708 8.766 0 17.76-1.778 24.221-4.326 0 0 1.238-.598.697-2.034l-4.199-11.599zM837.497 319.238c.811-5.507 2.334-10.09 4.682-13.661 3.544-5.422 8.951-8.396 16.551-8.396s12.623 2.988 16.223 8.396c2.391 3.571 3.43 8.354 3.843 13.661h-41.299zm57.592-12.111c-1.451-5.479-5.052-11.015-7.414-13.548-3.729-4.013-7.371-6.816-10.986-8.382-4.725-2.021-10.389-3.358-16.593-3.358-7.229 0-13.79 1.21-19.112 3.714-5.336 2.505-9.818 5.921-13.334 10.176-3.516 4.24-6.162 9.292-7.842 15.027-1.693 5.707-2.547 11.926-2.547 18.485 0 6.675.883 12.894 2.633 18.486 1.765 5.636 4.582 10.602 8.396 14.714 3.799 4.142 8.695 7.387 14.558 9.648 5.821 2.249 12.894 3.416 21.019 3.401 16.722-.057 25.53-3.785 29.159-5.792.641-.355 1.253-.981.483-2.774l-3.785-10.603c-.568-1.579-2.177-.996-2.177-.996-4.142 1.537-10.032 4.298-23.766 4.27-8.979-.014-15.64-2.661-19.81-6.803-4.283-4.24-6.375-10.474-6.745-19.268l57.905.057s1.522-.028 1.68-1.509c.057-.624 1.993-11.895-1.722-24.945M373.762 319.238c.825-5.507 2.334-10.09 4.682-13.661 3.543-5.422 8.951-8.396 16.55-8.396s12.623 2.988 16.237 8.396c2.376 3.571 3.415 8.354 3.828 13.661h-41.297zm57.577-12.111c-1.451-5.479-5.037-11.015-7.399-13.548-3.729-4.013-7.372-6.816-10.986-8.382-4.725-2.021-10.388-3.358-16.593-3.358-7.215 0-13.79 1.21-19.112 3.714-5.336 2.505-9.819 5.921-13.334 10.176-3.515 4.24-6.162 9.292-7.841 15.027-1.679 5.707-2.547 11.926-2.547 18.485 0 6.675.882 12.894 2.633 18.486 1.765 5.636 4.583 10.602 8.396 14.714 3.8 4.142 8.695 7.387 14.558 9.648 5.821 2.249 12.893 3.416 21.019 3.401 16.721-.057 25.53-3.785 29.159-5.792.641-.355 1.252-.981.484-2.774l-3.771-10.603c-.584-1.579-2.191-.996-2.191-.996-4.141 1.537-10.019 4.298-23.78 4.27-8.965-.014-15.625-2.661-19.795-6.803-4.284-4.24-6.375-10.474-6.746-19.268l57.905.057s1.522-.028 1.679-1.509c.055-.624 1.99-11.895-1.738-24.945M248.601 357.153c-2.263-1.808-2.576-2.263-3.344-3.43-1.139-1.779-1.722-4.312-1.722-7.528 0-5.095 1.679-8.752 5.166-11.214-.042.015 4.981-4.34 16.792-4.184 8.296.114 15.71 1.338 15.71 1.338v26.327h.014s-7.357 1.579-15.639 2.077c-11.783.712-17.02-3.4-16.977-3.386m23.039-40.686c-2.348-.171-5.394-.271-9.037-.271-4.966 0-9.762.626-14.259 1.836-4.525 1.209-8.595 3.103-12.096 5.606a27.927 27.927 0 0 0-8.396 9.549c-2.049 3.814-3.088 8.311-3.088 13.349 0 5.123.882 9.577 2.647 13.221 1.765 3.657 4.312 6.702 7.556 9.051 3.216 2.348 7.187 4.069 11.797 5.108 4.54 1.039 9.691 1.565 15.327 1.565 5.934 0 11.854-.483 17.589-1.466 5.678-.968 12.651-2.377 14.586-2.817a146.25 146.25 0 0 0 4.056-1.039c1.438-.355 1.324-1.893 1.324-1.893l-.029-52.952c0-11.613-3.102-20.223-9.207-25.559-6.077-5.322-15.028-8.013-26.597-8.013-4.341 0-11.328.599-15.512 1.438 0 0-12.651 2.448-17.86 6.518 0 0-1.138.712-.512 2.306l4.099 11.015c.512 1.423 1.893.939 1.893.939s.441-.171.954-.47c11.143-6.062 25.231-5.877 25.231-5.877 6.262 0 11.072 1.252 14.316 3.742 3.159 2.419 4.767 6.076 4.767 13.789v2.448c-4.981-.711-9.549-1.123-9.549-1.123M738.669 286.631c.44-1.31-.484-1.936-.869-2.078-.981-.384-5.905-1.423-9.705-1.665-7.271-.441-11.312.783-14.928 2.405-3.586 1.622-7.57 4.24-9.791 7.215v-7.044c0-.982-.697-1.765-1.665-1.765h-14.843c-.967 0-1.664.782-1.664 1.765v86.366c0 .968.797 1.765 1.764 1.765h15.213a1.76 1.76 0 0 0 1.75-1.765v-43.147c0-5.792.641-11.569 1.922-15.198 1.252-3.587 2.96-6.461 5.066-8.525 2.12-2.049 4.525-3.486 7.158-4.297 2.689-.826 5.663-1.096 7.77-1.096 3.031 0 6.361.782 6.361.782 1.109.128 1.736-.555 2.105-1.565.997-2.647 3.815-10.574 4.356-12.153"></path><path fill="#FFF" d="M595.874 246.603c-1.85-.569-3.529-.954-5.721-1.366-2.221-.398-4.867-.598-7.869-.598-10.475 0-18.729 2.96-24.52 8.794-5.764 5.807-9.678 14.644-11.642 26.271l-.712 3.913h-13.148s-1.594-.057-1.936 1.68l-2.148 12.053c-.157 1.139.342 1.864 1.878 1.864h12.794l-12.979 72.463c-1.011 5.835-2.178 10.631-3.473 14.273-1.267 3.587-2.504 6.276-4.041 8.24-1.48 1.879-2.875 3.273-5.295 4.084-1.992.669-4.297.982-6.816.982-1.395 0-3.258-.229-4.639-.513-1.366-.271-2.092-.569-3.131-1.011 0 0-1.494-.568-2.092.926-.47 1.238-3.885 10.615-4.298 11.769-.398 1.152.171 2.049.896 2.319 1.708.598 2.974.996 5.294 1.551 3.217.755 5.934.797 8.481.797 5.322 0 10.189-.754 14.217-2.205 4.042-1.466 7.57-4.014 10.701-7.457 3.373-3.729 5.493-7.628 7.515-12.964 2.006-5.266 3.729-11.812 5.094-19.439l13.05-73.815h19.069s1.607.057 1.936-1.693l2.162-12.039c.143-1.152-.341-1.864-1.893-1.864h-18.514c.1-.412.939-6.931 3.06-13.063.911-2.604 2.618-4.725 4.056-6.177 1.424-1.423 3.06-2.433 4.854-3.017 1.835-.598 3.928-.882 6.219-.882 1.736 0 3.457.199 4.752.469 1.793.385 2.49.584 2.961.727 1.893.569 2.148.014 2.519-.896l4.426-12.153c.455-1.312-.669-1.867-1.067-2.023M337.194 371.834c0 .968-.697 1.751-1.665 1.751h-15.355c-.968 0-1.651-.783-1.651-1.751v-123.58c0-.967.683-1.75 1.651-1.75h15.355c.968 0 1.665.783 1.665 1.75v123.58z"></path></g></svg>

                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        Salesforce Platform Event
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger by Salesforce Platform Event
                      </div>
                    </div>
                  </div>
                </label>
              </div>

              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="sns-checkbox"
                  value="SNS"
                  className="peer hidden"
                  checked={selectedSourceOption === "SNS"} // Control with state
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="sns-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <AwsSns />
                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        AWS SNS Trigger
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger it by sending messages to an AWS SNS topic
                      </div>
                    </div>
                  </div>
                </label>
              </div>

              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="sqs-checkbox"
                  value="SQS"
                  className="peer hidden"
                  checked={selectedSourceOption === "SQS"}
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="sqs-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <AwsSqs />
                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        AWS SQS Trigger
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger it by sending messages to an AWS SQS Queue
                      </div>
                    </div>
                  </div>
                </label>
              </div>

              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="azuresb-checkbox"
                  value="AZURE_SB"
                  className="peer hidden"
                  checked={selectedSourceOption === "AZURE_SB"} // Control with state
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="azuresb-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <AzureSb />
                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        Azure Service Bus Trigger
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger it by sending messages to an Azure Service Bus Queue
                      </div>
                    </div>
                  </div>
                </label>
              </div>

              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="WEBSOCKETS-checkbox"
                  value="WEBSOCKETS"
                  className="peer hidden"
                  checked={selectedSourceOption === "WEBSOCKETS"} // Control with state
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="WEBSOCKETS-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <GraphQlIcon />
                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        Websocket Trigger
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger through Websockets
                      </div>
                    </div>
                  </div>
                </label>
              </div>

              <div className="w-72 h-36">
                <input
                  type="radio"
                  name="options"
                  id="option3-checkbox"
                  value="Timer Trigger"
                  className="peer hidden"
                  checked={selectedSourceOption === "Timer Trigger"}
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="option3-checkbox"
                  className="group inline-flex w-full h-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                >
                  <div className="flex items-center space-x-5">
                    <svg
                      className="h-auto w-16"
                      viewBox="0 0 30 30"
                      version="1.1"
                      fill="#000000"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        className="h-auto w-16"
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <g
                          id="Page-1"
                          stroke="none"
                          strokeWidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          {" "}
                          <g
                            id="Icon-Set"
                            transform="translate(-519.000000, -360.000000)"
                            fill="#000000"
                          >
                            {" "}
                            <path
                              d="M533,374.184 L533,369 C533,368.448 532.553,368 532,368 C531.447,368 531,368.448 531,369 L531,374.184 C529.838,374.597 529,375.695 529,377 C529,378.657 530.343,380 532,380 C533.657,380 535,378.657 535,377 C535,375.695 534.162,374.597 533,374.184 L533,374.184 Z M532,388 C525.925,388 521,383.075 521,377 C521,370.925 525.925,366 532,366 C538.075,366 543,370.925 543,377 C543,383.075 538.075,388 532,388 L532,388 Z M532.99,364.05 C532.991,364.032 533,364.018 533,364 L533,362 L537,362 C537.553,362 538,361.553 538,361 C538,360.447 537.553,360 537,360 L527,360 C526.447,360 526,360.447 526,361 C526,361.553 526.447,362 527,362 L531,362 L531,364 C531,364.018 531.009,364.032 531.01,364.05 C524.295,364.558 519,370.154 519,377 C519,384.18 524.82,390 532,390 C539.18,390 545,384.18 545,377 C545,370.154 539.705,364.558 532.99,364.05 L532.99,364.05 Z"
                              id="timer"
                            >
                              {" "}
                            </path>{" "}
                          </g>{" "}
                        </g>{" "}
                      </g>
                    </svg>
                    <div className="flex flex-col justify-start">
                      <div className="w-full text-lg font-semibold">
                        Timer Trigger
                      </div>
                      <div className="w-full text-sm opacity-60">
                        Trigger it by a CRON expression (Timer)
                      </div>
                    </div>
                  </div>
                </label>
              </div>

            </div>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 gap-4 gap-y-2 text-sm lg:grid-cols-3">
        {details && details.triggerDetails.triggerType !== "None" && (
          <div className="text-gray-600">
            <div className="flex">
              <div className="mx-auto w-full pr-4">
                <div className="mx-auto max-w-md space-y-6">
                  <div className="space-y-4">
                    <p className="text-sm font-medium text-white">
                    Select the Trigger Type for your Integration
                    </p>

                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="option1-checkbox"
                        value="Http Trigger"
                        className="peer hidden"
                        checked={selectedSourceOption === "Http Trigger"} // Control with state
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="option1-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <svg
                            className="h-auto w-16"
                            viewBox="0 0 512 512"
                            fill="#000000"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <g>
                                {" "}
                                <path
                                  style={{ fill: "#B0B6BB" }}
                                  d="M308.145,406.069c-1.836,5.12-6.691,8.828-12.42,8.828h-70.621c-5.729,0-10.593-3.708-12.429-8.828 H5.102c-2.825,0-5.102,2.286-5.102,5.102v25.106c0,2.816,2.278,5.102,5.102,5.102h501.795c2.816,0,5.102-2.286,5.102-5.102v-25.106 c0-2.816-2.286-5.102-5.102-5.102H308.145z"
                                ></path>{" "}
                                <path
                                  style={{ fill: "#E8EDEE" }}
                                  d="M212.678,406.069c1.836,5.12,6.691,8.828,12.42,8.828h70.621c5.729,0,10.593-3.708,12.429-8.828 H494.34V97.103c0-14.627-11.855-26.483-26.483-26.483H44.133c-14.627,0-26.483,11.855-26.483,26.483v308.966H212.678z"
                                ></path>{" "}
                                <polygon
                                  style={{ fill: "#7383BF" }}
                                  points="52.963,370.759 459.032,370.759 459.032,105.931 52.963,105.931 "
                                ></polygon>{" "}
                                <g>
                                  {" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M105.928,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C114.756,278.528,110.801,282.483,105.928,282.483"
                                  ></path>{" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M158.894,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C167.721,278.528,163.767,282.483,158.894,282.483"
                                  ></path>{" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M220.687,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C229.515,278.528,225.56,282.483,220.687,282.483"
                                  ></path>{" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M158.894,247.172h-52.966c-4.873,0-8.828-3.955-8.828-8.828s3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828S163.767,247.172,158.894,247.172"
                                  ></path>{" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M247.17,211.862h-52.966c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828C255.997,207.907,252.043,211.862,247.17,211.862"
                                  ></path>{" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M308.963,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.955,8.828,8.828v70.621C317.79,278.528,313.836,282.483,308.963,282.483"
                                  ></path>{" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M335.446,211.862H282.48c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828C344.273,207.907,340.318,211.862,335.446,211.862"
                                  ></path>{" "}
                                  <path
                                    style={{ fill: "#FFFFFF" }}
                                    d="M379.584,233.931h11.034c6.082,0,11.034-4.952,11.034-11.034s-4.952-11.034-11.034-11.034h-11.034 V233.931z M370.756,282.483c-4.873,0-8.828-3.955-8.828-8.828v-70.621c0-4.873,3.955-8.828,8.828-8.828h19.862 c15.819,0,28.69,12.871,28.69,28.69s-12.871,28.69-28.69,28.69h-11.034v22.069C379.584,278.528,375.629,282.483,370.756,282.483 L370.756,282.483z"
                                  ></path>
                                </g>{" "}
                              </g>{" "}
                            </g>
                          </svg>
                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              Http Trigger
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger it by HTTP request
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="option2-checkbox"
                        value="Webhook Trigger"
                        className="peer hidden"
                        checked={selectedSourceOption === "Webhook Trigger"} // Control with state
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="option2-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <svg
                            className="h-auto w-16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12.52 3.046a3 3 0 0 0-2.13 5.486 1 1 0 0 1 .306 1.38l-3.922 6.163a2 2 0 1 1-1.688-1.073l3.44-5.405a5 5 0 1 1 8.398-2.728 1 1 0 1 1-1.97-.348 3 3 0 0 0-2.433-3.475zM10 6a2 2 0 1 1 3.774.925l3.44 5.405a5 5 0 1 1-1.427 8.5 1 1 0 0 1 1.285-1.532 3 3 0 1 0 .317-4.83 1 1 0 0 1-1.38-.307l-3.923-6.163A2 2 0 0 1 10 6zm-5.428 6.9a1 1 0 0 1-.598 1.281A3 3 0 1 0 8.001 17a1 1 0 0 1 1-1h8.266a2 2 0 1 1 0 2H9.9a5 5 0 1 1-6.61-5.698 1 1 0 0 1 1.282.597Z"
                                fill="#000000"
                              ></path>{" "}
                            </g>
                          </svg>
                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              Webhook Trigger
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger it by webhook
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="salesforce-checkbox"
                        value="SALESFORCE"
                        className="peer hidden"
                        checked={selectedSourceOption === "SALESFORCE"} // Control with state
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="salesforce-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <svg className="h-auto w-16" viewBox="0.5 -149.38 999 999" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#00A1E0" d="M416.224 76.763c32.219-33.57 77.074-54.391 126.682-54.391 65.946 0 123.48 36.772 154.12 91.361 26.626-11.896 56.098-18.514 87.106-18.514 118.94 0 215.368 97.268 215.368 217.247 0 119.993-96.428 217.261-215.368 217.261a213.735 213.735 0 0 1-42.422-4.227c-26.981 48.128-78.397 80.646-137.412 80.646-24.705 0-48.072-5.706-68.877-15.853-27.352 64.337-91.077 109.448-165.348 109.448-77.344 0-143.261-48.939-168.563-117.574-11.057 2.348-22.513 3.572-34.268 3.572C75.155 585.74.5 510.317.5 417.262c0-62.359 33.542-116.807 83.378-145.937-10.26-23.608-15.967-49.665-15.967-77.06C67.911 87.25 154.79.5 261.948.5c62.914 0 118.827 29.913 154.276 76.263"></path><path fill="#FFF" d="M145.196 363.11c-.626 1.637.228 1.979.427 2.263 1.878 1.366 3.786 2.349 5.707 3.444 10.189 5.407 19.81 6.986 29.871 6.986 20.492 0 33.214-10.9 33.214-28.447v-.341c0-16.224-14.358-22.115-27.835-26.37l-1.75-.569c-10.161-3.302-18.927-6.147-18.927-12.836v-.355c0-5.721 5.123-9.934 13.064-9.934 8.823 0 19.297 2.932 26.042 6.66 0 0 1.978 1.281 2.704-.64.398-1.025 3.814-10.218 4.17-11.214.384-1.082-.299-1.879-.996-2.306-7.699-4.682-18.344-7.884-29.358-7.884l-2.049.014c-18.756 0-31.848 11.328-31.848 27.565v.342c0 17.119 14.444 22.669 27.978 26.54l2.177.669c9.862 3.031 18.358 5.635 18.358 12.58v.342c0 6.347-5.521 11.071-14.43 11.071-3.458 0-14.487-.071-26.398-7.6-1.438-.84-2.277-1.451-3.387-2.12-.583-.37-2.049-1.011-2.689.925l-4.045 11.215zM445.194 363.11c-.626 1.637.228 1.979.427 2.263 1.878 1.366 3.786 2.349 5.706 3.444 10.189 5.407 19.811 6.986 29.871 6.986 20.492 0 33.215-10.9 33.215-28.447v-.341c0-16.224-14.359-22.115-27.836-26.37l-1.75-.569c-10.161-3.302-18.928-6.147-18.928-12.836v-.355c0-5.721 5.123-9.934 13.064-9.934 8.823 0 19.297 2.932 26.043 6.66 0 0 1.978 1.281 2.703-.64.398-1.025 3.814-10.218 4.17-11.214.385-1.082-.299-1.879-.996-2.306-7.699-4.682-18.344-7.884-29.358-7.884l-2.05.014c-18.756 0-31.848 11.328-31.848 27.565v.342c0 17.119 14.444 22.669 27.978 26.54l2.177.669c9.862 3.031 18.373 5.635 18.373 12.58v.342c0 6.347-5.536 11.071-14.445 11.071-3.457 0-14.486-.071-26.397-7.6-1.438-.84-2.291-1.423-3.372-2.12-.371-.242-2.107-.911-2.705.925l-4.042 11.215zM649.995 328.74c0 9.919-1.85 17.731-5.493 23.253-3.601 5.465-9.051 8.126-16.649 8.126-7.613 0-13.035-2.647-16.579-8.126-3.587-5.507-5.407-13.334-5.407-23.253 0-9.904 1.82-17.703 5.407-23.168 3.544-5.407 8.966-8.04 16.579-8.04 7.599 0 13.049 2.633 16.664 8.04 3.629 5.464 5.478 13.263 5.478 23.168m17.106-18.386c-1.68-5.679-4.298-10.688-7.784-14.857-3.487-4.184-7.898-7.542-13.136-9.99-5.223-2.433-11.398-3.671-18.328-3.671-6.945 0-13.121 1.238-18.344 3.671-5.237 2.448-9.648 5.807-13.149 9.99-3.472 4.184-6.091 9.193-7.784 14.857-1.665 5.649-2.505 11.825-2.505 18.386s.84 12.751 2.505 18.386c1.693 5.664 4.298 10.674 7.799 14.857 3.486 4.184 7.912 7.528 13.135 9.904 5.236 2.377 11.398 3.586 18.344 3.586 6.93 0 13.092-1.209 18.328-3.586 5.223-2.376 9.648-5.721 13.136-9.904 3.486-4.17 6.104-9.179 7.784-14.857 1.68-5.649 2.519-11.84 2.519-18.386s-.841-12.737-2.52-18.386M807.568 357.47c-.569-1.665-2.177-1.039-2.177-1.039-2.49.954-5.138 1.836-7.955 2.277-2.861.44-6.006.669-9.379.669-8.281 0-14.856-2.462-19.566-7.329-4.725-4.867-7.372-12.736-7.344-23.381.029-9.691 2.362-16.978 6.561-22.527 4.17-5.521 10.517-8.354 18.984-8.354 7.059 0 12.438.811 18.072 2.59 0 0 1.352.583 1.992-1.181 1.494-4.156 2.604-7.13 4.198-11.698.456-1.295-.654-1.85-1.053-2.007-2.22-.868-7.457-2.276-11.413-2.874-3.7-.569-8.026-.868-12.836-.868-7.188 0-13.591 1.224-19.069 3.672-5.465 2.433-10.104 5.791-13.775 9.976-3.672 4.184-6.461 9.192-8.325 14.856-1.85 5.649-2.789 11.854-2.789 18.415 0 14.188 3.828 25.657 11.385 34.054 7.57 8.425 18.941 12.708 33.77 12.708 8.766 0 17.76-1.778 24.221-4.326 0 0 1.238-.598.697-2.034l-4.199-11.599zM837.497 319.238c.811-5.507 2.334-10.09 4.682-13.661 3.544-5.422 8.951-8.396 16.551-8.396s12.623 2.988 16.223 8.396c2.391 3.571 3.43 8.354 3.843 13.661h-41.299zm57.592-12.111c-1.451-5.479-5.052-11.015-7.414-13.548-3.729-4.013-7.371-6.816-10.986-8.382-4.725-2.021-10.389-3.358-16.593-3.358-7.229 0-13.79 1.21-19.112 3.714-5.336 2.505-9.818 5.921-13.334 10.176-3.516 4.24-6.162 9.292-7.842 15.027-1.693 5.707-2.547 11.926-2.547 18.485 0 6.675.883 12.894 2.633 18.486 1.765 5.636 4.582 10.602 8.396 14.714 3.799 4.142 8.695 7.387 14.558 9.648 5.821 2.249 12.894 3.416 21.019 3.401 16.722-.057 25.53-3.785 29.159-5.792.641-.355 1.253-.981.483-2.774l-3.785-10.603c-.568-1.579-2.177-.996-2.177-.996-4.142 1.537-10.032 4.298-23.766 4.27-8.979-.014-15.64-2.661-19.81-6.803-4.283-4.24-6.375-10.474-6.745-19.268l57.905.057s1.522-.028 1.68-1.509c.057-.624 1.993-11.895-1.722-24.945M373.762 319.238c.825-5.507 2.334-10.09 4.682-13.661 3.543-5.422 8.951-8.396 16.55-8.396s12.623 2.988 16.237 8.396c2.376 3.571 3.415 8.354 3.828 13.661h-41.297zm57.577-12.111c-1.451-5.479-5.037-11.015-7.399-13.548-3.729-4.013-7.372-6.816-10.986-8.382-4.725-2.021-10.388-3.358-16.593-3.358-7.215 0-13.79 1.21-19.112 3.714-5.336 2.505-9.819 5.921-13.334 10.176-3.515 4.24-6.162 9.292-7.841 15.027-1.679 5.707-2.547 11.926-2.547 18.485 0 6.675.882 12.894 2.633 18.486 1.765 5.636 4.583 10.602 8.396 14.714 3.8 4.142 8.695 7.387 14.558 9.648 5.821 2.249 12.893 3.416 21.019 3.401 16.721-.057 25.53-3.785 29.159-5.792.641-.355 1.252-.981.484-2.774l-3.771-10.603c-.584-1.579-2.191-.996-2.191-.996-4.141 1.537-10.019 4.298-23.78 4.27-8.965-.014-15.625-2.661-19.795-6.803-4.284-4.24-6.375-10.474-6.746-19.268l57.905.057s1.522-.028 1.679-1.509c.055-.624 1.99-11.895-1.738-24.945M248.601 357.153c-2.263-1.808-2.576-2.263-3.344-3.43-1.139-1.779-1.722-4.312-1.722-7.528 0-5.095 1.679-8.752 5.166-11.214-.042.015 4.981-4.34 16.792-4.184 8.296.114 15.71 1.338 15.71 1.338v26.327h.014s-7.357 1.579-15.639 2.077c-11.783.712-17.02-3.4-16.977-3.386m23.039-40.686c-2.348-.171-5.394-.271-9.037-.271-4.966 0-9.762.626-14.259 1.836-4.525 1.209-8.595 3.103-12.096 5.606a27.927 27.927 0 0 0-8.396 9.549c-2.049 3.814-3.088 8.311-3.088 13.349 0 5.123.882 9.577 2.647 13.221 1.765 3.657 4.312 6.702 7.556 9.051 3.216 2.348 7.187 4.069 11.797 5.108 4.54 1.039 9.691 1.565 15.327 1.565 5.934 0 11.854-.483 17.589-1.466 5.678-.968 12.651-2.377 14.586-2.817a146.25 146.25 0 0 0 4.056-1.039c1.438-.355 1.324-1.893 1.324-1.893l-.029-52.952c0-11.613-3.102-20.223-9.207-25.559-6.077-5.322-15.028-8.013-26.597-8.013-4.341 0-11.328.599-15.512 1.438 0 0-12.651 2.448-17.86 6.518 0 0-1.138.712-.512 2.306l4.099 11.015c.512 1.423 1.893.939 1.893.939s.441-.171.954-.47c11.143-6.062 25.231-5.877 25.231-5.877 6.262 0 11.072 1.252 14.316 3.742 3.159 2.419 4.767 6.076 4.767 13.789v2.448c-4.981-.711-9.549-1.123-9.549-1.123M738.669 286.631c.44-1.31-.484-1.936-.869-2.078-.981-.384-5.905-1.423-9.705-1.665-7.271-.441-11.312.783-14.928 2.405-3.586 1.622-7.57 4.24-9.791 7.215v-7.044c0-.982-.697-1.765-1.665-1.765h-14.843c-.967 0-1.664.782-1.664 1.765v86.366c0 .968.797 1.765 1.764 1.765h15.213a1.76 1.76 0 0 0 1.75-1.765v-43.147c0-5.792.641-11.569 1.922-15.198 1.252-3.587 2.96-6.461 5.066-8.525 2.12-2.049 4.525-3.486 7.158-4.297 2.689-.826 5.663-1.096 7.77-1.096 3.031 0 6.361.782 6.361.782 1.109.128 1.736-.555 2.105-1.565.997-2.647 3.815-10.574 4.356-12.153"></path><path fill="#FFF" d="M595.874 246.603c-1.85-.569-3.529-.954-5.721-1.366-2.221-.398-4.867-.598-7.869-.598-10.475 0-18.729 2.96-24.52 8.794-5.764 5.807-9.678 14.644-11.642 26.271l-.712 3.913h-13.148s-1.594-.057-1.936 1.68l-2.148 12.053c-.157 1.139.342 1.864 1.878 1.864h12.794l-12.979 72.463c-1.011 5.835-2.178 10.631-3.473 14.273-1.267 3.587-2.504 6.276-4.041 8.24-1.48 1.879-2.875 3.273-5.295 4.084-1.992.669-4.297.982-6.816.982-1.395 0-3.258-.229-4.639-.513-1.366-.271-2.092-.569-3.131-1.011 0 0-1.494-.568-2.092.926-.47 1.238-3.885 10.615-4.298 11.769-.398 1.152.171 2.049.896 2.319 1.708.598 2.974.996 5.294 1.551 3.217.755 5.934.797 8.481.797 5.322 0 10.189-.754 14.217-2.205 4.042-1.466 7.57-4.014 10.701-7.457 3.373-3.729 5.493-7.628 7.515-12.964 2.006-5.266 3.729-11.812 5.094-19.439l13.05-73.815h19.069s1.607.057 1.936-1.693l2.162-12.039c.143-1.152-.341-1.864-1.893-1.864h-18.514c.1-.412.939-6.931 3.06-13.063.911-2.604 2.618-4.725 4.056-6.177 1.424-1.423 3.06-2.433 4.854-3.017 1.835-.598 3.928-.882 6.219-.882 1.736 0 3.457.199 4.752.469 1.793.385 2.49.584 2.961.727 1.893.569 2.148.014 2.519-.896l4.426-12.153c.455-1.312-.669-1.867-1.067-2.023M337.194 371.834c0 .968-.697 1.751-1.665 1.751h-15.355c-.968 0-1.651-.783-1.651-1.751v-123.58c0-.967.683-1.75 1.651-1.75h15.355c.968 0 1.665.783 1.665 1.75v123.58z"></path></g></svg>

                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              Salesforce Platform Event
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger by Salesforce Platform Event
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="sns-checkbox"
                        value="SNS"
                        className="peer hidden"
                        checked={selectedSourceOption === "SNS"} // Control with state
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="sns-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <AwsSns />
                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              AWS SNS Trigger
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger it by sending messages to an AWS SNS topic
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="sqs-checkbox"
                        value="SQS"
                        className="peer hidden"
                        checked={selectedSourceOption === "SQS"}
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="sqs-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <AwsSqs />
                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              AWS SQS Trigger
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger it by sending messages to an AWS SQS Queue
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="azuresb-checkbox"
                        value="AZURE_SB"
                        className="peer hidden"
                        checked={selectedSourceOption === "AZURE_SB"} // Control with state
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="azuresb-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <AzureSb />
                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              Azure Service Bus Trigger
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger it by sending messages to an Azure Service Bus Queue
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>


                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="WEBSOCKETS-checkbox"
                        value="WEBSOCKETS"
                        className="peer hidden"
                        checked={selectedSourceOption === "WEBSOCKETS"} // Control with state
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="WEBSOCKETS-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <GraphQlIcon />
                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              Websocket Trigger
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger through Websockets
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>

                    <div className="relative">
                      <input
                        type="radio"
                        name="options"
                        id="option3-checkbox"
                        value="Timer Trigger"
                        className="peer hidden"
                        checked={selectedSourceOption === "Timer Trigger"}
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="option3-checkbox"
                        className="group inline-flex w-full cursor-pointer items-center justify-between rounded-lg border-2 border-neutral-200/70 bg-white p-5 text-neutral-600 hover:border-neutral-300 hover:text-neutral-900 peer-checked:border-blue-400 peer-checked:bg-blue-200/50 peer-checked:text-neutral-900"
                      >
                        <div className="flex items-center space-x-5">
                          <svg
                            className="h-auto w-16"
                            viewBox="0 0 30 30"
                            version="1.1"
                            fill="#000000"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              className="h-auto w-16"
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <g
                                id="Page-1"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                {" "}
                                <g
                                  id="Icon-Set"
                                  transform="translate(-519.000000, -360.000000)"
                                  fill="#000000"
                                >
                                  {" "}
                                  <path
                                    d="M533,374.184 L533,369 C533,368.448 532.553,368 532,368 C531.447,368 531,368.448 531,369 L531,374.184 C529.838,374.597 529,375.695 529,377 C529,378.657 530.343,380 532,380 C533.657,380 535,378.657 535,377 C535,375.695 534.162,374.597 533,374.184 L533,374.184 Z M532,388 C525.925,388 521,383.075 521,377 C521,370.925 525.925,366 532,366 C538.075,366 543,370.925 543,377 C543,383.075 538.075,388 532,388 L532,388 Z M532.99,364.05 C532.991,364.032 533,364.018 533,364 L533,362 L537,362 C537.553,362 538,361.553 538,361 C538,360.447 537.553,360 537,360 L527,360 C526.447,360 526,360.447 526,361 C526,361.553 526.447,362 527,362 L531,362 L531,364 C531,364.018 531.009,364.032 531.01,364.05 C524.295,364.558 519,370.154 519,377 C519,384.18 524.82,390 532,390 C539.18,390 545,384.18 545,377 C545,370.154 539.705,364.558 532.99,364.05 L532.99,364.05 Z"
                                    id="timer"
                                  >
                                    {" "}
                                  </path>{" "}
                                </g>{" "}
                              </g>{" "}
                            </g>
                          </svg>
                          <div className="flex flex-col justify-start">
                            <div className="w-full text-lg font-semibold">
                              Timer Trigger
                            </div>
                            <div className="w-full text-sm opacity-60">
                              Trigger it by a CRON expression (Timer)
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {details && details.triggerDetails.triggerType !== "None" && (
          <div className="lg:col-span-2 text-white">
            <div className="text-lg font-medium">Integration Details</div>
            <div>Please fill the integration details.</div>
            <div className="grid grid-cols-1 gap-4 gap-y-2 text-sm md:grid-cols-5 mt-6">
              <div className="md:col-span-5">
                <label htmlFor="int_name">Name</label>
                <input
                  maxLength={30}
                  type="text"
                  name="int_name"
                  id="int_name"
                  className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                  placeholder="Name of the integration"
                  value={name}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mt-2 md:col-span-5">
                <label htmlFor="descr">Description</label>
                <input
                  maxLength={50}
                  type="text"
                  name="descr"
                  id="descr"
                  className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                  placeholder="Brief description of the integration"
                  value={description}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex md:col-span-5"></div>

              {(selectedSourceOption === "SNS" || selectedSourceOption === "SQS") && (
                <div className="flex space-x-2 md:col-span-5">
                  <div className="w-1/5">
                    <label htmlFor="int_name">AWS Region</label>
                    <input
                      type="text"
                      name="awsRegion"
                      id="awsRegion"
                      className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                      placeholder="us-east-1"
                      value={awsRegion}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="w-2/5">
                    <label htmlFor="int_name">AWS Access Key Id</label>
                    <input
                      type="text"
                      name="awsAccessKeyId"
                      id="awsAccessKeyId"
                      className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                      placeholder="AWS Access Key Id"
                      value={awsAccessKeyId}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="w-2/5">
                    <label htmlFor="int_name">AWS Secret Access Key</label>
                    <input
                      type="password"
                      name="awsSecretAccessKey"
                      id="awsSecretAccessKey"
                      className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                      placeholder="AWS Secret Access Key"
                      value={awsSecretAccessKey}
                      onChange={handleInputChange}
                    />
                  </div>

                </div>
              )}

              {selectedSourceOption === "SNS" && (
                <div className="mt-2 md:col-span-5">
                  <label htmlFor="int_name">AWS SNS Topic ARN</label>
                  <input
                    type="text"
                    name="awsSNSTopicArn"
                    id="awsSNSTopicArn"
                    className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                    placeholder="AWS SNS Topic ARN"
                    value={awsSNSTopicArn}
                    onChange={handleInputChange}
                  />
                </div>
              )}


              {selectedSourceOption === "SQS" && (
                <div className="mt-2 md:col-span-5">
                  <label htmlFor="int_name">AWS SQS Queue URL</label>
                  <input
                    type="text"
                    name="awsSQSQueueUrl"
                    id="awsSQSQueueUrl"
                    className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                    placeholder="AWS SQS Queue URL"
                    value={awsSQSQueueUrl}
                    onChange={handleInputChange}
                  />
                </div>
              )}

              {selectedSourceOption === "AZURE_SB" && (
                <>
                  <div className="mt-2 md:col-span-5">
                    <label htmlFor="int_name">Azure Service Bus Queue Name</label>
                    <input
                      type="text"
                      name="azSbQueueName"
                      id="azSbQueueName"
                      className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                      placeholder="Azure Service Bus Queue Name"
                      value={azSbQueueName}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="mt-2 md:col-span-5">
                    <label htmlFor="int_name">Azure Service Bus Connection String</label>
                    <input
                      type="text"
                      name="azSbConnectionString"
                      id="azSbConnectionString"
                      className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                      placeholder="Azure Service Bus Connection String"
                      value={azSbConnectionString}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              )}

              {selectedSourceOption === "SALESFORCE" && (
                <>
                  <div className="flex space-x-2 md:col-span-5">
                    <div className="mt-2 w-1/2">
                      <label htmlFor="int_name">Instance URL</label>
                      <input
                        type="text"
                        name="sfInstanceUrl"
                        id="sfInstanceUrl"
                        className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        placeholder="Salesforce Instance URL"
                        value={sfInstanceUrl}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="mt-2 w-1/2">
                      <label htmlFor="int_name">Platform Event Topic Name</label>
                      <input
                        type="text"
                        name="sfTopicName"
                        id="sfTopicName"
                        className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        placeholder="Salesforce Topic Name"
                        value={sfTopicName}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="mt-2 flex space-x-2 md:col-span-5">
                    <div className="mt-2 w-1/2">
                      <label htmlFor="int_name">User Name</label>
                      <input
                        autoComplete="off"
                        type="text"
                        name="sfUserName"
                        id="sfUserName"
                        className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        placeholder="Salesforce User Name"
                        value={sfUserName}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="mt-2 w-1/2">
                      <label htmlFor="int_name">Password</label>
                      <input
                        autoComplete="off"
                        type="password"
                        name="sfPassword"
                        id="sfPassword"
                        className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        placeholder="Salesforce Password"
                        value={sfPassword}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="mt-2 flex space-x-2 md:col-span-5">
                    <div className="mt-2 w-1/3 md:col-span-5">
                      <label htmlFor="int_name">Security Token</label>
                      <input
                        type="text"
                        name="sfSecurityToken"
                        id="sfSecurityToken"
                        className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        placeholder="Salesforce Security Token"
                        value={sfSecurityToken}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="mt-2 w-1/3 md:col-span-5">
                      <label htmlFor="int_name">Salesforce Client Id</label>
                      <input
                        type="text"
                        name="sfClientId"
                        id="sfClientId"
                        className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        placeholder="Salesforce Client Id"
                        value={sfClientId}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="mt-2 w-1/3 md:col-span-5">
                      <label htmlFor="int_name">Client Secret</label>
                      <input
                        type="password"
                        name="sfClientSecret"
                        id="sfClientSecret"
                        className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        placeholder="Salesforce Client Secret"
                        value={sfClientSecret}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {(selectedSourceOption === "Http Trigger"
                || selectedSourceOption === "Webhook Trigger"
                || selectedSourceOption === "SNS"
                || selectedSourceOption === "SQS"
                || selectedSourceOption === "AZURE_SB"
                || selectedSourceOption === "SALESFORCE"
              ) && (
                  <>
                    <div className="flex md:col-span-5">
                      {(selectedSourceOption !== "SNS"
                        && selectedSourceOption !== "SQS"
                        && selectedSourceOption !== "AZURE_SB"
                        && selectedSourceOption !== "SALESFORCE"
                      ) && (
                          <>
                            <div className="w-1/3">
                              <div>
                                <label htmlFor="http_method">Http Method</label>
                              </div>
                              <div className="relative mt-2 inline-block w-64 text-left">
                                <button
                                  onClick={onDropDownMethod}
                                  className="inline-flex w-full items-center justify-between rounded border border-gray-200 bg-white px-4 py-2 text-gray-700 dark:border-slate-700 dark:bg-[#20293A] dark:text-gray-400"
                                >
                                  <span>{selectedTriggerHttpMethod}</span>
                                  <svg
                                    className="ml-2 h-4 w-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M19 9l-7 7-7-7"
                                    ></path>
                                  </svg>
                                </button>
                                {showDropdownMethod && (
                                  <div className="opacity-1 bg-white-500 absolute z-40 mt-0 w-full rounded-md border border-gray-200 bg-white shadow-lg dark:border-slate-700 dark:bg-[#20293A]">
                                    <div
                                      className="py-1 text-sm text-gray-700 dark:text-gray-400"
                                      role="menu"
                                      aria-orientation="vertical"
                                      aria-labelledby="options-menu"
                                    >
                                      <a
                                        onClick={() => onDropDownOptionSelected('GET')}
                                        href="#"
                                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                                        role="menuitem"
                                      >
                                        GET
                                      </a>
                                      <a
                                        onClick={() => onDropDownOptionSelected('POST')}
                                        href="#"
                                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                                        role="menuitem"
                                      >
                                        POST
                                      </a>
                                      <a
                                        onClick={() => onDropDownOptionSelected('PATCH')}
                                        href="#"
                                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                                        role="menuitem"
                                      >
                                        PATCH
                                      </a>
                                      <a
                                        onClick={() => onDropDownOptionSelected('DELETE')}
                                        href="#"
                                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                                        role="menuitem"
                                      >
                                        DELETE
                                      </a>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="w-1/3">
                              <div>
                                <div className="flex items-center">
                                  <label htmlFor="header_key" className="mr-1">Request Signature Header Key</label>
                                  <div className="group relative">
                                    <svg
                                      className="h-4 w-4 cursor-pointer text-blue-600 hover:text-gray-600"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                      ></path>
                                    </svg>
                                    <div className="bg-white border border-gray-800 text-gray-900 absolute bottom-full left-1/2 z-20 mb-2 w-64 -translate-x-1/2 transform rounded-md px-3 py-2 text-sm opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                                      This is the HTTP header key that will be used to verify the signature of the incoming request. For example, X-Hub-Signature-256.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="relative mt-2 inline-block w-64 text-left">
                                <input
                                  type="text"
                                  name="header_key"
                                  id="header_key"
                                  className="h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                                  placeholder="e.g., X-Hub-Signature"
                                  value={SignatureHeaderKey}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>

                            <div className="w-1/3">
                              <div>
                                <div className="flex items-center">
                                  <label htmlFor="client_secret_key" className="mr-1">Client Secret</label>
                                  <div className="group relative">
                                    <svg
                                      className="h-4 w-4 cursor-pointer text-blue-600 hover:text-gray-600"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                      ></path>
                                    </svg>
                                    <div className="bg-white border border-x-gray-900 text-gray-900 absolute bottom-full left-1/2 z-20 mb-2 w-64 -translate-x-1/2 transform rounded-md px-3 py-2 text-sm opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                                      This is the client secret key that will be used to verify the signature of the incoming request. For example, sha256=1234567890abcdef.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="relative mt-2 inline-block w-64 text-left">
                                <input
                                  type="password"
                                  name="client_secret_key"
                                  id="client_secret_key"
                                  className="h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                                  placeholder="Client Secret"
                                  value={ClientSecret}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </>
                        )}
                    </div>
                    <div className="md:col-span-5">
                      <div className="flex items-center justify-between">
                        <label htmlFor="descr">Request Payload Schema</label>
                        <button onClick={fillSampleRequestSchema} className="rounded-md p-2 text-blue-700 hover:bg-gray-200">Use a sample</button>
                      </div>
                      <textarea
                        type="textarea"
                        rows={10}
                        name="request_schema"
                        id="request_schema"
                        className="mt-1 h-40 w-full text-gray-900 rounded border bg-gray-50 px-4"
                        value={requestSchema}
                        onChange={handleInputChange}
                      />
                    </div>
                    {(selectedSourceOption !== 'SNS'
                      && selectedSourceOption !== 'SQS'
                      && selectedSourceOption !== 'AZURE_SB'
                      && selectedSourceOption !== 'SALESFORCE'
                    ) && (
                        <div className="md:col-span-5">
                          <div className="flex items-center justify-between">
                            <label htmlFor="descr">Response Schema</label>
                            <button onClick={fillSampleResponseSchema} className="rounded-md p-2 text-blue-700 hover:bg-gray-200">Use a sample</button>
                          </div>
                          <textarea
                            type="textarea"
                            rows={10}
                            name="response_schema"
                            id="response_schema"
                            className="mt-1 h-40 w-full text-gray-900 rounded border bg-gray-50 px-4"
                            value={responseSchema}
                            onChange={handleInputChange}
                          />
                        </div>
                      )}
                  </>
                )}

              {selectedSourceOption === "Timer Trigger" && (
                <div className="md:col-span-5">
                  <label htmlFor="int_name">Cron Expression</label>
                  <input
                    type="text"
                    name="cron_expression"
                    id="cron_expression"
                    className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
                    placeholder="e.g., * 1-10 * * * *"
                    value={cronExpression}
                    onChange={handleInputChange}
                  />
                </div>
              )}



            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default OverviewDetails;
